import TubCommon from "./tubCommon";

export default class ReplacementTub extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'replacement_tub';
    this.bottomTubId = "replacement_tub";
    this.visible = true;
    this.partName = 'Replacement Tub';
    this.translateId = "visualizer.bathroom.shower_tub_combo.replacement_tub";
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
    this.canBeDisabled = true;
    if (isChild) {
      this.oneLayerPosition = true;
    }
  }

  navigationSubItems(filters, searchText) {
    return this.navigationSubItemsWithSides(filters, searchText);
  }

  handleClick(...props) {
    if (this.isStandaloneReplacementTub(this)) {
      const bathtubParent = this.getParent().getParent().layout.parts.Bathtub;
      if (bathtubParent?.bathTubBody?.activeFeature && !bathtubParent.bathTubBody.disabled) {
        bathtubParent.bathTubBody.disabled = true;
        // bathtubParent.bathTubBody.disabledClick(); // can't do that, because we still need enclosures
        // ["bathTubFixture", "enclosureTop", "enclosureBottom"].forEach(relName => {
        ["enclosureTop", "enclosureBottom"].forEach(relName => {
          if (bathtubParent[relName]) {
            bathtubParent[relName].disabled = false;
          }
        });
        if (bathtubParent["bathTubFixture"]) {
          bathtubParent["bathTubFixture"].disabled = true;
        }
      }
    }
    return super.handleClick(...props);
  }

  hideLayerCondition() {
    if (this.getParent().layout?.type === 11 && this.isStandaloneReplacementTub(this.activeFeature)) {
      const bathtubParent = this.getParent().layout?.parts.Bathtub;
      return bathtubParent?.bathTubBody?.activeFeature && !bathtubParent.bathTubBody.disabled;
    }
    return super.hideLayerCondition()
  }

  isStandaloneReplacementTub(forFeature = this.activeFeature) {
    return forFeature?.dbFeature?.metaData?.["MountType"]?.includes("D")
  }

  disabledClick() {
    const bathtubParent = this.getParent().layout.parts.Bathtub;
    ["bathTubFixture", "enclosureTop", "enclosureBottom"].forEach(relName => {
      if (bathtubParent[relName]) {
        bathtubParent[relName].disabled = this.disabled;
      }
    })
  }

}
